// src/SubscribeComponent.tsx
import { FormEvent, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import styles from './SubscribeComponent.module.css';

const SIGNUP_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbzhE9ymaDeUZH-taViUJnc_a5PZ7_uWbgjz4pZXlnzBSrPDCc8OmGs5SVBDAA4wSBz_9A/exec';
const SIGNUP_TOKEN = '7068b83e-baf8-4ee2-896c-73a469fbdfba';
const STORAGE_KEY = 'cr-email-signup';
const EMAIL_RE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

type Status = 'idle' | 'submitting' | 'success' | 'error';

const SubscribeComponent: React.FC = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const [showInvalid, setShowInvalid] = useState(false);

  // Persisted across visits: the email this browser already signed up with.
  const [registeredEmail, setRegisteredEmail] = useState<string | null>(null);
  useEffect(() => {
    setRegisteredEmail(localStorage.getItem(STORAGE_KEY));
  }, []);

  // One-time CSRF nonce sent alongside the submission.
  const csrfToken = useMemo(() => Math.random().toString(36).substring(2), []);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!EMAIL_RE.test(email)) {
      setShowInvalid(true);
      return;
    }
    setShowInvalid(false);
    setStatus('submitting');
    try {
      await axios.post(
        SIGNUP_ENDPOINT,
        { email, token: SIGNUP_TOKEN, csrfToken },
        { headers: { 'Content-Type': 'text/plain' } }
      );
      localStorage.setItem(STORAGE_KEY, email);
      setRegisteredEmail(email);
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };

  if (registeredEmail) {
    return (
      <div className={styles.subscribe}>
        <p className={styles.thanks}>
          Thanks for signing up, <strong>{registeredEmail}</strong>! We'll keep you
          posted.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.subscribe}>
      <p className={styles.blurb}>
        Stay updated on the game's progress — join our mailing list.
      </p>
      <Form noValidate onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.field}>
          <Form.Control
            size="lg"
            type="email"
            placeholder="Enter your email"
            aria-label="Email address"
            value={email}
            isInvalid={showInvalid}
            onChange={(e) => {
              setEmail(e.target.value);
              if (showInvalid) setShowInvalid(false);
            }}
            className={styles.input}
            required
          />
          <Button
            type="submit"
            size="lg"
            className={styles.button}
            disabled={status === 'submitting'}
          >
            {status === 'submitting' ? 'Joining…' : 'Subscribe'}
          </Button>
        </div>
        {showInvalid && (
          <p className={styles.invalid}>Please enter a valid email.</p>
        )}
        {status === 'error' && (
          <p className={styles.invalid}>
            Something went wrong — please try again.
          </p>
        )}
      </Form>
    </div>
  );
};

export default SubscribeComponent;
